import { getParam, isToufangWebView } from './tools'
import Cookies from 'js-cookie';
import {AD_ID_COOKIES_KEY, IS_TOUFANG_STORE_KEY, LOVERFLIX_FROM_STORE_KEY, USER_ID_COOKIES_KEY, USER_TOKEN_COOKIES_KEY, LOVERFLIX_USER_ID_COOKIES_KEY, LOVERFLIX_USER_TOKEN_COOKIES_KEY} from './constant'

// 图片地址
export const IMG_BASE_URL = 'https://static.novelfreedom.com/';
export const LOCAL_IMG_URL = IMG_BASE_URL + 'h5_img';
export const COS_IMG_ADDRESS = 'aivideo/user/';
export const COS_IMG_URL = IMG_BASE_URL + COS_IMG_ADDRESS;

const identityMemory = {}

const getIdentityCookieOptions = (expires = 365) => {
    const options = {
        expires,
        path: '/',
        sameSite: 'Lax'
    }
    const hostname = window.location.hostname

    if (window.location.protocol === 'https:') {
        options.secure = true
    }
    if (hostname === 'mysexualpersona.com' || hostname.endsWith('.mysexualpersona.com')) {
        options.domain = '.mysexualpersona.com'
    }

    return options
}

const writeStorageValue = (storage, key, value) => {
    try {
        storage.setItem(key, value)
    } catch (error) {
        // Some in-app browsers may temporarily block a storage layer.
    }
}

const readStorageValue = (storage, key) => {
    try {
        return storage.getItem(key) || ''
    } catch (error) {
        return ''
    }
}

const persistIdentityValue = (key, value, expires = 365) => {
    if (!value) return

    const normalizedValue = String(value)
    identityMemory[key] = normalizedValue
    writeStorageValue(window.localStorage, key, normalizedValue)
    writeStorageValue(window.sessionStorage, key, normalizedValue)

    try {
        Cookies.set(key, normalizedValue, getIdentityCookieOptions(expires))
    } catch (error) {
        // Storage fallbacks keep the identity available if cookies are blocked.
    }
}

const getIdentityValue = (key) => {
    const cookieValue = Cookies.get(key) || ''
    const localValue = readStorageValue(window.localStorage, key)
    const sessionValue = readStorageValue(window.sessionStorage, key)
    const value = identityMemory[key] || localValue || sessionValue || cookieValue || ''
    const shouldSyncCookie = cookieValue !== value || !identityMemory[key]

    if (value) {
        identityMemory[key] = value
        if (shouldSyncCookie) {
            try {
                Cookies.set(key, value, getIdentityCookieOptions())
            } catch (error) {
                // Continue using the available storage layer.
            }
        }
        if (localValue !== value) writeStorageValue(window.localStorage, key, value)
        if (sessionValue !== value) writeStorageValue(window.sessionStorage, key, value)
    }

    return value
}

export const getStoredUserId = () => getIdentityValue(USER_ID_COOKIES_KEY)
export const getStoredUserToken = () => getIdentityValue(USER_TOKEN_COOKIES_KEY)
export const getStoredAdId = () => getIdentityValue(AD_ID_COOKIES_KEY)
// https://static.novelfreedom.com/paynovel/h5-pay-asia/


// 获取版本号
export const getVersion = () => {
    return '1.0.2'
}

// 获取fb pixel id
export const getFbPixelId = () => {
    return APP_CONFIG[getAppIdConfig()]?.fbPixleId || APP_CONFIG['default'].fbPixleId
}

export const getTtPixelId = () => {
    return APP_CONFIG[getAppIdConfig()]?.ttPixelId || APP_CONFIG['default'].ttPixelId
}

export const getPathLang = () => {
    const app = getAppIdConfig();
    return APP_CONFIG[app]?.lang || APP_CONFIG['default'].lang || 'en'
}

export const getDomain = () => {
    return 'question'
    // if(process.env.NODE_ENV === 'dev'){
    //     return 'aiface_h5';
    // }
    // if(process.env.VUE_APP_ENV === 'test'){
    //     return 'aiface_h5';
    // }

    // let host = location.host && location.host.split('.'); 
    
    // return host.length < 2 ? "" : host[host.length -2];
}

export const getAppID = ()=>{
    return getDomain();
}

export const getAppIdConfig = () => {
    const appId = getAppID();
    // if(appId === 'loverflix' && getParam('adf')){
    //     return 'loverflix_' + getParam('adf'); 
    // }
    return appId;
}


export const getShowNewPay = () => {
    const appId = getAppIdConfig();
    return ['novellettes'].includes(appId);
}

export const getShowPaykka = () => {
    const appId = getAppIdConfig();
    return appId.includes('durianovel')
}

export const setCookieFbc = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');
    if (fbclid) {
        const fbc = `fb.1.${Date.now()}.${fbclid}`;
        document.cookie = `_fbc=${encodeURIComponent(fbc)}; max-age=7776000; path=/; SameSite=Lax`;
    }
}

export const setCookieAdId = () => {
    const adId = getParam('af_ad_id') || getParam('utm_content')
    if (adId) {
        persistIdentityValue(AD_ID_COOKIES_KEY, adId)
    }
}

export const APP_CONFIG = {
    default: {
        fbPixleId: '1562155112015720',
        ttPixelId: 'D1NMVABC77U5LQ9964K0',
        moneySymbol: '$',
        lang: 'en',
        company: 'mysexualpersona.com',
        name: 'Sexual Persona',
        email: 'p@novellettes.com',
        companyName: 'Clockwise International (HongKong) Limited',
        address: 'FLAT/RM A 12/F ZJ 300, 300 LOCKHART ROAD, WAN CHAI, HK',
        // 支付是否需要登陆后支付
        payIslogin: false
    }
}

export const getAppInfo = () => {
    const appId = getAppIdConfig()
    const obj = {
        name: APP_CONFIG[appId]?.name || APP_CONFIG['default'].name,
        company: APP_CONFIG[appId]?.company || APP_CONFIG['default'].company,
        fbPixleId: APP_CONFIG[appId]?.fbPixleId || APP_CONFIG['default'].fbPixleId,
        ttPixelId: APP_CONFIG[appId]?.ttPixelId || APP_CONFIG['default'].ttPixelId,
        email: APP_CONFIG[appId]?.email || APP_CONFIG['default'].email,
        payIslogin: APP_CONFIG[appId]?.payIslogin || APP_CONFIG['default'].payIslogin,
        privacy: APP_CONFIG[appId]?.privacy || null,
        service: APP_CONFIG[appId]?.service || null,
        companyName: APP_CONFIG[appId]?.companyName || APP_CONFIG['default'].companyName,
        address: APP_CONFIG[appId]?.address || APP_CONFIG['default'].address,
    }
    return obj
}

// cookie 设置用户
export const setUserInfo = (id, token) => {
    let expires = 365
    if(getAppIdConfig() === 'loverflix'){
        expires = 90
    }
    persistIdentityValue(USER_ID_COOKIES_KEY, id, expires)
    persistIdentityValue(USER_TOKEN_COOKIES_KEY, token, expires)
}

export const isApplePayApp = () => {
    // const app = ['loverflix'];
    // return app.includes(getAppID());
    return true
}

// 是否是投放用户
export const isToufang = () => {
    return getParam('ch')
}

export const isTtChannel = () => {
    return !!getParam('ttclid')
}

export function setToufang() {
    if(!getParam('ch')){
        if(isToufangWebView()){
           const location = window.location
            let search = ''
            if(location.search){
                search = '&ch=1'
            }else{
                search = '?ch=1'
            }
            this.$router.push(`${location.pathname + location.search}${search}`)
        }

    }
}
